<div class="reservation-list-container">
  <div class="list-header">
    <h2>Pronađene rezervacije</h2>
    <p>{{ reservations.length }} rezultata</p>
  </div>

  <div *ngIf="reservations.length === 0" class="empty-state">
    <div class="empty-state-content">
      <mat-icon class="empty-icon">search_off</mat-icon>
      <h3>Nema pronađenih rezervacija</h3>
      <p>Pokušajte ponovno s drugim unosom</p>
    </div>
  </div>

  <div *ngIf="reservations.length > 0" class="reservations-list">
    <mat-card *ngFor="let res of reservations" class="reservation-card" (click)="onSelectReservation(res)">
      <mat-card-content>
        <div class="guest-info">
          <div class="guest-avatar">
            <mat-icon>person</mat-icon>
          </div>
          <div class="guest-details">
            <h3>{{ getGuestName(res) }}</h3>
            <p class="email">{{ getGuestEmail(res) }}</p>
          </div>
        </div>
        <div class="reservation-details">
          <div class="detail-item">
            <mat-icon class="detail-icon">confirmation_number</mat-icon>
            <div class="detail-content">
              <span class="detail-label">Šifra rezervacije</span>
              <span class="detail-value">{{ res.identifier }}</span>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon class="detail-icon">calendar_today</mat-icon>
            <div class="detail-content">
              <span class="detail-label">Dolazak</span>
              <span class="detail-value">{{ parseDate(res?.startDate) }}</span>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon class="detail-icon">event</mat-icon>
            <div class="detail-content">
              <span class="detail-label">Odlazak</span>
              <span class="detail-value">{{ parseDate(res.endDate) }}</span>
            </div>
          </div>
          <div class="detail-item">
            <mat-icon class="detail-icon">account_balance_wallet</mat-icon>
            <div class="detail-content">
              <span class="detail-label">Iznos</span>
              <span class="detail-value">{{ res.totalPrice }}</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="actions">
    <button mat-raised-button (click)="onBack()">
      <mat-icon>arrow_back</mat-icon>
      Natrag
    </button>
  </div>
</div>
